// extracted by mini-css-extract-plugin
module.exports = {"root":"TransactionPage_root__3Tp0Y","loading":"TransactionPage_loading__RYpcd","error":"TransactionPage_error__2UqNG","footer":"TransactionPage_footer__sjdKc"};